/** Generate by swagger-axios-codegen */
// @ts-nocheck
/* eslint-disable */

/** Generate by swagger-axios-codegen */
/* eslint-disable */
// @ts-nocheck
import axiosStatic, { type AxiosInstance, type AxiosRequestConfig } from 'axios';

export interface IRequestOptions extends AxiosRequestConfig {
  /**
   * show loading status
   */
  loading?: boolean;
  /**
   * display error message
   */
  showError?: boolean;
  /**
   * data security, extended fields are encrypted using the specified algorithm
   */
  security?: Record<string, 'md5' | 'sha1' | 'aes' | 'des'>;
  /**
   * indicates whether Authorization credentials are required for the request
   * @default true
   */
  withAuthorization?: boolean;
}

export interface IRequestConfig {
  method?: any;
  headers?: any;
  url?: any;
  data?: any;
  params?: any;
}

// Add options interface
export interface ServiceOptions {
  axios?: AxiosInstance;
  /** only in axios interceptor config*/
  loading: boolean;
  showError: boolean;
}

// Add default options
export const serviceOptions: ServiceOptions = {};

// Instance selector
export function axios(configs: IRequestConfig, resolve: (p: any) => void, reject: (p: any) => void): Promise<any> {
  if (serviceOptions.axios) {
    return serviceOptions.axios
      .request(configs)
      .then((res) => {
        resolve(res.data);
      })
      .catch((err) => {
        reject(err);
      });
  } else {
    throw new Error('please inject yourself instance like axios  ');
  }
}

export function getConfigs(method: string, contentType: string, url: string, options: any): IRequestConfig {
  const configs: IRequestConfig = {
    loading: serviceOptions.loading,
    showError: serviceOptions.showError,
    ...options,
    method,
    url
  };
  configs.headers = {
    ...options.headers,
    'Content-Type': contentType
  };
  return configs;
}

export const basePath = '';

export interface IList<T> extends Array<T> {}
export interface List<T> extends Array<T> {}
export interface IDictionary<TValue> {
  [key: string]: TValue;
}
export interface Dictionary<TValue> extends IDictionary<TValue> {}

export interface IListResult<T> {
  items?: T[];
}

export class ListResultDto<T> implements IListResult<T> {
  items?: T[];
}

export interface IPagedResult<T> extends IListResult<T> {
  totalCount?: number;
  items?: T[];
}

export class PagedResultDto<T = any> implements IPagedResult<T> {
  totalCount?: number;
  items?: T[];
}

// customer definition
// empty

export class DocRecognitionService {
  /**
   *
   */
  static newTask(
    params: {
      /**  */
      file: any;
      /**  */
      name: string;
      /**  */
      projectId: string;
      /**  */
      authorEmployeeId: string;
      /**  */
      tableName: string;
      /**  */
      tableRowId: string;
      /**  */
      existingRecId: string;
      /**  */
      awareOfApprove: boolean;
      /**  */
      service: string;
      /**  */
      description: string;
      /**  */
      systemSection: string;
      /** id документа-источника, к которому привязан создаваемый документ (PUSK-6120, заявка) */
      linkDocId?: string;
      /** имя таблицы документа-источника (PUSK-6120, напр. 'pusk.request') */
      linkTableName?: string;
      /** requestBody */
      body?: NewDocMetaDto;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['file'] != null) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      if (params['name'] != null) {
        if (Object.prototype.toString.call(params['name']) === '[object Array]') {
          for (const item of params['name']) {
            data.append('name', item as any);
          }
        } else {
          data.append('name', params['name'] as any);
        }
      }

      if (params['projectId'] != null) {
        if (Object.prototype.toString.call(params['projectId']) === '[object Array]') {
          for (const item of params['projectId']) {
            data.append('project_id', item as any);
          }
        } else {
          data.append('project_id', params['projectId'] as any);
        }
      }

      if (params['authorEmployeeId'] != null) {
        if (Object.prototype.toString.call(params['authorEmployeeId']) === '[object Array]') {
          for (const item of params['authorEmployeeId']) {
            data.append('author_employee_id', item as any);
          }
        } else {
          data.append('author_employee_id', params['authorEmployeeId'] as any);
        }
      }

      if (params['tableName'] != null) {
        if (Object.prototype.toString.call(params['tableName']) === '[object Array]') {
          for (const item of params['tableName']) {
            data.append('table_name', item as any);
          }
        } else {
          data.append('table_name', params['tableName'] as any);
        }
      }

      if (params['tableRowId'] != null) {
        if (Object.prototype.toString.call(params['tableRowId']) === '[object Array]') {
          for (const item of params['tableRowId']) {
            data.append('table_row_id', item as any);
          }
        } else {
          data.append('table_row_id', params['tableRowId'] as any);
        }
      }

      if (params['existingRecId'] != null) {
        if (Object.prototype.toString.call(params['existingRecId']) === '[object Array]') {
          for (const item of params['existingRecId']) {
            data.append('existing_rec_id', item as any);
          }
        } else {
          data.append('existing_rec_id', params['existingRecId'] as any);
        }
      }

      if (params['awareOfApprove'] != null) {
        if (Object.prototype.toString.call(params['awareOfApprove']) === '[object Array]') {
          for (const item of params['awareOfApprove']) {
            data.append('awareOfApprove', item as any);
          }
        } else {
          data.append('awareOfApprove', params['awareOfApprove'] as any);
        }
      }

      if (params['service'] != null) {
        if (Object.prototype.toString.call(params['service']) === '[object Array]') {
          for (const item of params['service']) {
            data.append('service', item as any);
          }
        } else {
          data.append('service', params['service'] as any);
        }
      }

      if (params['description'] != null) {
        if (Object.prototype.toString.call(params['description']) === '[object Array]') {
          for (const item of params['description']) {
            data.append('description', item as any);
          }
        } else {
          data.append('description', params['description'] as any);
        }
      }

      if (params['systemSection'] != null) {
        if (Object.prototype.toString.call(params['systemSection']) === '[object Array]') {
          for (const item of params['systemSection']) {
            data.append('systemSection', item as any);
          }
        } else {
          data.append('systemSection', params['systemSection'] as any);
        }
      }

      if (params['linkDocId'] != null) {
        data.append('link_doc_id', params['linkDocId'] as any);
      }

      if (params['linkTableName'] != null) {
        data.append('link_table_name', params['linkTableName'] as any);
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static newTaskFromExistingFile(
    params: {
      /** requestBody */
      body?: NewDocFromExistingFileMeta;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks/from-existing';

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      let data = params.body;

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getTransformedDoc(
    params: {
      /**  */
      taskId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks/{taskId}/transformed';
      url = url.replace('{taskId}', params['taskId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getOriginalDoc(
    params: {
      /**  */
      taskId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks/{taskId}/original';
      url = url.replace('{taskId}', params['taskId'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static verifyTask(
    params: {
      /**  */
      taskId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks/{taskId}/verify';
      url = url.replace('{taskId}', params['taskId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static discardTask(
    params: {
      /**  */
      taskId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/tasks/{taskId}/discard';
      url = url.replace('{taskId}', params['taskId'] + '');

      const configs: IRequestConfig = getConfigs('post', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getDocumentRenderedPage(
    params: {
      /**  */
      docId: string;
      /**  */
      page: number;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/task-docs/{docId}/pages/{page}';
      url = url.replace('{docId}', params['docId'] + '');
      url = url.replace('{page}', params['page'] + '');

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static observeDocuments(
    params: {
      /**  */
      org: string;
      /**  */
      employeeId: string;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/observeDocuments';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);
      configs.params = { org: params['org'], employee_id: params['employeeId'] };

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static getBalance(options: IRequestOptions = {}): Promise<RecognitionBalance> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/balance';

      const configs: IRequestConfig = getConfigs('get', 'application/json', url, options);

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static recognizeAi(
    params: {
      /**  */
      file: any;
      /**  */
      mimeType: string;
      /**  */
      languageCodes: [];
      /**  */
      model: string;
      /**  */
      gptModel: string;
      /**  */
      prompt: string;
      /**  */
      responseFormat: object;
      /** requestBody */
      body?: OCRData;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/recognize-ai';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['file'] != null) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      if (params['mimeType'] != null) {
        if (Object.prototype.toString.call(params['mimeType']) === '[object Array]') {
          for (const item of params['mimeType']) {
            data.append('mimeType', item as any);
          }
        } else {
          data.append('mimeType', params['mimeType'] as any);
        }
      }

      if (params['languageCodes'] != null) {
        if (Object.prototype.toString.call(params['languageCodes']) === '[object Array]') {
          for (const item of params['languageCodes']) {
            data.append('languageCodes', item as any);
          }
        } else {
          data.append('languageCodes', params['languageCodes'] as any);
        }
      }

      if (params['model'] != null) {
        if (Object.prototype.toString.call(params['model']) === '[object Array]') {
          for (const item of params['model']) {
            data.append('model', item as any);
          }
        } else {
          data.append('model', params['model'] as any);
        }
      }

      if (params['gptModel'] != null) {
        if (Object.prototype.toString.call(params['gptModel']) === '[object Array]') {
          for (const item of params['gptModel']) {
            data.append('gpt_model', item as any);
          }
        } else {
          data.append('gpt_model', params['gptModel'] as any);
        }
      }

      if (params['prompt'] != null) {
        if (Object.prototype.toString.call(params['prompt']) === '[object Array]') {
          for (const item of params['prompt']) {
            data.append('prompt', item as any);
          }
        } else {
          data.append('prompt', params['prompt'] as any);
        }
      }

      if (params['responseFormat'] != null) {
        if (Object.prototype.toString.call(params['responseFormat']) === '[object Array]') {
          for (const item of params['responseFormat']) {
            data.append('response_format', item as any);
          }
        } else {
          data.append('response_format', params['responseFormat'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
  /**
   *
   */
  static recoveryAsTextDoc(
    params: {
      /**  */
      file: any;
      /**  */
      mimeType: string;
      /**  */
      languageCodes: [];
      /**  */
      model: string;
      /**  */
      blake3FileHash: string;
      /** requestBody */
      body?: RecoveryOCRData;
    } = {} as any,
    options: IRequestOptions = {}
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      let url = basePath + '/recovery-as-text-doc';

      const configs: IRequestConfig = getConfigs('post', 'multipart/form-data', url, options);

      let data = params.body;
      data = new FormData();
      if (params['file'] != null) {
        if (Object.prototype.toString.call(params['file']) === '[object Array]') {
          for (const item of params['file']) {
            data.append('file', item as any);
          }
        } else {
          data.append('file', params['file'] as any);
        }
      }

      if (params['mimeType'] != null) {
        if (Object.prototype.toString.call(params['mimeType']) === '[object Array]') {
          for (const item of params['mimeType']) {
            data.append('mimeType', item as any);
          }
        } else {
          data.append('mimeType', params['mimeType'] as any);
        }
      }

      if (params['languageCodes'] != null) {
        if (Object.prototype.toString.call(params['languageCodes']) === '[object Array]') {
          for (const item of params['languageCodes']) {
            data.append('languageCodes', item as any);
          }
        } else {
          data.append('languageCodes', params['languageCodes'] as any);
        }
      }

      if (params['model'] != null) {
        if (Object.prototype.toString.call(params['model']) === '[object Array]') {
          for (const item of params['model']) {
            data.append('model', item as any);
          }
        } else {
          data.append('model', params['model'] as any);
        }
      }

      if (params['blake3FileHash'] != null) {
        if (Object.prototype.toString.call(params['blake3FileHash']) === '[object Array]') {
          for (const item of params['blake3FileHash']) {
            data.append('blake3FileHash', item as any);
          }
        } else {
          data.append('blake3FileHash', params['blake3FileHash'] as any);
        }
      }

      configs.data = data;

      axios(configs, resolve, reject);
    });
  }
}

export interface NewDocMetaDto {
  /**  */
  file: string;

  /**  */
  name: string;

  /**  */
  project_id: string;

  /**  */
  author_employee_id: string;

  /**  */
  table_name: string;

  /**  */
  table_row_id?: string;

  /**  */
  existing_rec_id?: string;

  /**  */
  awareOfApprove?: boolean;

  /**  */
  service?: string;

  /**  */
  description?: string;

  /**  */
  systemSection?: string;
}

export interface NewDocFromExistingFileMeta {
  /**  */
  fileGuid: string;

  /**  */
  forMatchingDoc?: boolean;

  /**  */
  name: string;

  /**  */
  project_id: string;

  /**  */
  author_employee_id: string;

  /**  */
  table_name: string;

  /**  */
  table_row_id?: string;

  /**  */
  existing_rec_id?: string;

  /**  */
  awareOfApprove?: boolean;

  /**  */
  service?: string;

  /**  */
  description?: string;

  /**  */
  systemSection?: string;
}

export interface RecognitionBalance {
  /**  */
  used: number;

  /**  */
  balance?: number;

  /**  */
  available: number;
}

export interface OCRData {
  /**  */
  file: string;

  /**  */
  mimeType: string;

  /**  */
  languageCodes?: string[];

  /**  */
  model?: string;

  /**  */
  gpt_model?: string;

  /**  */
  prompt?: string;

  /**  */
  response_format?: object;
}

export interface RecoveryOCRData {
  /**  */
  file: string;

  /**  */
  mimeType: string;

  /**  */
  languageCodes?: string[];

  /**  */
  model?: string;

  /**  */
  blake3FileHash: string;
}
